import React, { Fragment } from "react"
import { TextField, CircularProgress, Button } from "@material-ui/core"
import useStyles from "./styles"
import { Box } from "../../../../../node_modules/@material-ui/core/index"
import CharacterCounter from "../../Common/CharacterCounter/index"

const AdditionalBillingData = ({
  onChange,
  adBillingValue,
  submitAdBillingInfo,
  loading,
  saveButton = true,
  disabled = false,
  boxWidth = "100%",
}) => {
  const classes = useStyles()
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  return (
    <Fragment>
      <Box display="flex" justifyContent="flex-end">
        <CharacterCounter
          typingLength={adBillingValue ? adBillingValue.length : 0}
          maxLength={2000}
        />
      </Box>
      <TextField
        id="note-box"
        multiline
        placeholder=""
        margin="dense"
        onChange={onChange}
        value={adBillingValue}
        variant="outlined"
        className={classes.adBillignInfo}
        rows={4}
        rowsMax={12}
        disabled={disabled}
        style={{ width: boxWidth }}
      />
      {saveButton && (
        <div
          style={{
            display: "flex",
            width: boxWidth,
            justifyContent: "flex-end",
          }}
        >
          <Button
            className={classes.saveButton}
            variant="outlined"
            onClick={submitAdBillingInfo}
            disabled={
              disabled || (adBillingValue && adBillingValue.length > 2000)
            }
          >
            {loading ? (
              <CircularProgress size={20} className={classes.progress} />
            ) : (
              "Save"
            )}
          </Button>
        </div>
      )}
    </Fragment>
  )
}

export default AdditionalBillingData
